export enum StorageScheme {
    Embedded = 'Embedded',
    Independent = 'Independent'
}